export const API_URL = 'https://blog-male-server.vercel.app';